import { lerp, smoothstep01 } from '@/lib/utils/math'

export const BLOOM_SECTION_ID = 'fz-bloom-section'

const HEADLINE_TEXT = 'Diga o que as palavras não alcançam.'
const ENTER_END = 0.34
const EXIT_START = 0.66
const ENTER_OFFSET_VW = -46
const EXIT_OFFSET_VW = 42

export interface BloomSectionModelProps {
  progress: number
}

function resolveHeadlineMotion(progress: number): {
  offsetVw: number
  opacity: number
} {
  if (progress < ENTER_END) {
    const enter = smoothstep01(progress / ENTER_END)
    return { offsetVw: lerp(ENTER_OFFSET_VW, 0, enter), opacity: enter }
  }
  if (progress < EXIT_START) {
    return { offsetVw: 0, opacity: 1 }
  }
  const exit = smoothstep01((progress - EXIT_START) / (1 - EXIT_START))
  return { offsetVw: lerp(0, EXIT_OFFSET_VW, exit), opacity: 1 - exit }
}

export function useBloomSectionModel({ progress }: BloomSectionModelProps) {
  const motion = resolveHeadlineMotion(progress)

  return {
    sectionId: BLOOM_SECTION_ID,
    headlineText: HEADLINE_TEXT,
    stageInert: progress <= 0 || progress >= 1,
    headlineStyle: {
      transform: `translate3d(${motion.offsetVw.toFixed(2)}vw, 0, 0)`,
      opacity: Math.round(motion.opacity * 1000) / 1000,
    },
  }
}
